<template>
   <div class="accordion__item" :class="{'accordion__item--expanded': visible}">
        <div class="grid grid--middle accordion__trigger" @click="open" :rebuild="false">
            <span class="grid grid--middle grid--center accordion__title-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10" class="svg-chevron-empty">
                    <path d="M2.35 0L0 1.9 10 10l10-8.1L17.65 0 10 6.18z"/>
                </svg>
            </span>
            <span class="accordion__title-wrapper" v-if="customTags" v-html="title"></span>
            <span class="accordion__title-wrapper" v-else>{{ title }}</span>
        </div><div class="accordion__wrapper">
            <div class="accordion__content"><slot /></div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['title', 'customTags', 'rebuild'],
    inject: ['Accordion'],
    data() { return {index: undefined}; },
    computed: {
        visible() { return this.index === this.Accordion.active; }
    },
     methods: {
        open() { this.Accordion.active = this.visible ? null : this.index; },
    },
    created() { this.index = this.Accordion.count++ }
};
</script>
